import { Swiper } from "swiper/react";
import { Pagination } from "swiper";
import { ReactNode } from "react";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

type SwiperContainerProps = { 
    children: ReactNode;
    direction?: 'horizontal' | 'vertical';
    style?: any;
};

const SwiperContainer = ({ children, direction = 'horizontal', style}: SwiperContainerProps) => {

  return (
    <Swiper
        direction={direction}
        slidesPerView={3}
        spaceBetween={30}
        scrollbar={{ draggable: true }}
        pagination={{
            clickable: true
        }}
        modules={[Pagination]}
        style={style}
    >
        {children}
    </Swiper>
  );
}

export { SwiperContainer };
